import NewPasswordContainer from "./newPassword.container";

export default NewPasswordContainer;
